import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { Observable, from } from "rxjs";
import { Subject } from "rxjs";
import { SessionService } from "./session.service";
import { NavigationService } from "./navigation.service";
import { ActivatedRoute } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  public apiBaseUrl: any;
  public supportUrl: any;
  dashboardKey:any;
  executionUrl = "kpi/get-execution-details";
  triggerAction$ = new Subject<any>();
  

  trigger(value: any) {
    this.triggerAction$.next(value);
  }

  constructor(
    private httpClient: HttpClient,
    private route: ActivatedRoute,
    private navigationService: NavigationService
  ) {
    this.apiBaseUrl = environment.apiBaseUrl;
    this.supportUrl = environment.supportUrl;
    // Query Params
      this.route.queryParams.subscribe((params:any) => {
        const val = this.navigationService.decryptData(params);
        this.dashboardKey = val["ds_key"];
      });
  }

  login(data: any) {
    return this.httpClient.post(this.apiBaseUrl + "/api/user-validation", data);
  }
  getuserName(data: any) {
    return this.httpClient.post(
      this.apiBaseUrl + "/api/validate-pwd-key",
      data
    );
  }

  forgotPassowrd(data: any) {
    const obj = {
      user_id: data,
    };
    return this.httpClient.post(
      this.apiBaseUrl + "/api/send-pwd-confirmation",
      obj
    );
  }
  userActivity(data: any) {
    return this.httpClient.post(
      this.apiBaseUrl + "/api/log-user-activity",
      data
    );
  }

  getCongnitoUserStatus(data: any) {
    return this.httpClient.post(
      this.apiBaseUrl + "/api/get-cognito-user-status",
      data
    );
  }
  getDoc(url: string): Observable<any> {
    return this.httpClient.get(`assets/json/${url}.json`);
  }

  // Load a page config JSON directly from local assets (no backend call)
  getPageJsonFromAssets(fileName: string): Observable<any> {
    return this.httpClient.get(`assets/page_jsons/${fileName}`);
  }

  getlogos(): Observable<any> {
    let endPoint: any = "api/get-logos";
    return this.get(endPoint);
  }

  get(url: string): Observable<any> {
    return this.httpClient.get(`${this.apiBaseUrl}/${url}`);
  }
  
  gets(url: string): Observable<any> {
    const Url =  this.dashboardKey=='20260324013723' ? this.supportUrl : this.apiBaseUrl;
    return this.httpClient.get(`${Url}/${url}`)
  }

  post(url: string, data: any): Observable<any> {
    // Employee key and Client key
    if (this.getClientKey() && this.getEmpKey()) {
      let query: any = {
        client_key: this.getClientKey(),
        employee_key: this.getEmpKey(),
        module_key: this.getModuleKey(),
      };
      Object.assign(data, query);
    }

    
    return this.httpClient.post(`${this.apiBaseUrl}/${url}`, data);
  }
  
  posts(url: string, data: any): Observable<any> {
    
    // Employee key and Client key
    if(this.getClientKey() && this.getEmpKey()) {
      let query: any = {
        "client_key": this.getClientKey(),
        "employee_key": this.getEmpKey()
      }
      Object.assign(data, query)
    }
    
    const Url =  this.dashboardKey=='20260324013723' ? this.supportUrl : this.apiBaseUrl;
    return this.httpClient.post(`${Url}/${url}`, data)
  }

  postBlob(url: string, data: any): Observable<any> {
    // Employee key and Client key
    if (this.getClientKey() && this.getEmpKey()) {
      let query: any = {
        client_key: this.getClientKey(),
        employee_key: this.getEmpKey(),
        module_key: this.getModuleKey(),
      };
      Object.assign(data, query);
    }

    return this.httpClient.post(`${this.apiBaseUrl}/${url}`, data, {
      responseType: "blob",
    });
  }

  getEmpKey() {
    let emp: any = sessionStorage.getItem("employee_key");
    let employee_key = JSON.parse(emp);
    if (!employee_key) return false;
    return employee_key?._value;
  }

  getClientKey() {
    let client_key: any = sessionStorage.getItem("client");
    if (!client_key) return false;
    let value = JSON.parse(client_key);
    return value?.[0]?.client?.client_key || null;
  }

  getModuleKey() {
    let module: any = sessionStorage.getItem("module");
    if (!module) return "";
    let value = JSON.parse(module);
    return value?.module_key || "";
  }

  getBrandList(obj: any) {
    return this.httpClient.post(`${this.apiBaseUrl}/kpi/get-brand-filter`, obj);
  }

  alertKPIPost(url: string, data: any): Observable<any> {
    // Employee key and Client key
    if (this.getClientKey() && this.getEmpKey()) {
      let query: any = {
        client_key: this.getClientKey(),
        employee_key: this.getEmpKey(),
        module_key: this.getModuleKey(),
      };
      Object.assign(data, query);
    }

    return this.httpClient.post(`${this.apiBaseUrl}/${url}`, data);
  }

  alertKPIGet(url: string): Observable<any> {
    return this.httpClient.get(`${this.apiBaseUrl}/${url}`);
  }

  // New Calendar API
  //add and update event
  addEvent(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/events/update-events-data",
      data
    );
  }
  //get all Events
  getAllEvent(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/events/get-events-data",
      data
    );
  }
  //get all attendees
  getAllAttendees(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/events/get-event-attendees-data",
      data
    );
  }
  // delete event
  deleteEvent(data: any) {
    return this.httpClient.delete(
      environment.apiBaseUrl + "/api/events/delete-events-data",
      {
        body: data,
      }
    );
  }
  //update Attendees Status
  updateAttendeesStatus(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/events/update-attendee-status",
      data
    );
  }

  // PHI Verification Code
  sendPhiVerificationCode(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/send-phi-verification-code",
      data,
      { responseType: "text" }
    );
  }

  // Verify PHI Verification Code
  verifyPhiVerificationCode(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/verify-phi-verification-code",
      data,
      { responseType: "text" }
    );
  }
}
